function getGlobalConfigs() {
  if (typeof window !== 'undefined' && window.__client_configs__) { // eslint-disable-line
    return window.__client_configs__; // eslint-disable-line
  }
  return false;
}

export function getServerConfigs(clientSide = false) {
  const config = {
    appUrlPath: process.env.ENDPOINT,
    unsupportedBrowsers: 'https://www.axa.com.hk/unsupported-browser',
    environment: process.env.ENVIRONMENT
  };

  if (!clientSide) {
    config.oauthEndpoint = process.env.OAUTH_ENDPOINT;
    config.oauthClientId = process.env.OAUTH_CLIENTID;
    config.oauthClientSecret = process.env.OAUTH_CLIENT_SECRET;
    config.userManagementEndpoint = process.env.USER_MANAGEMENT_ENDPOINT;
    config.internalPath = process.env.INTERNAL_PATH;
    config.externalPath = process.env.EXTERNAL_PATH;
    config.httpsEnabled = process.env.HTTPS_ENABLED;
    config.importDbInit = process.env.IMPORT_DB_INIT;
    config.importCodeTables = process.env.IMPORT_CODE_TABLES;
    config.routesTimeout = process.env.ROUTES_TIMEOUT;
    config.mongo = {
      url: process.env.MONGODB_URL,
      cert: process.env.MONGODB_CERTIFICATE
    }
    config.IALevy =[
      { from: new Date('2017-12-31T16:00:00.000Z'), to: new Date('2019-03-31T16:00:00.000Z'), rate: 0.0004, cap: 2000 },
      { from: new Date('2019-03-31T16:00:00.000Z'), to: new Date('2020-03-31T16:00:00.000Z'), rate: 0.0006, cap: 3000 },
      { from: new Date('2020-03-31T16:00:00.000Z'), to: new Date('2021-03-31T16:00:00.000Z'), rate: 0.00085, cap: 4250 },
      { from: new Date('2021-03-31T16:00:00.000Z'), to: new Date('2099-03-31T16:00:00.000Z'), rate: 0.001, cap: 5000 }
    ]
    config.MIBRate = { from: new Date(process.env.MIBRATE_EFF_DATE_FROM), to: new Date(process.env.MIBRATE_EFF_DATE_TO), tempRate: parseFloat(process.env.MIB_TEMP_RATE), normalRate: parseFloat(process.env.MIB_NORMAL_RATE), defaultRate: 0.03}
    config.sessionSecrets = process.env.LIST_SESSION_SECRETS;

    config.midas_apikey = process.env.MIDAS_APIKEY;
    config.midas_url = process.env.MIDAS_URL;
    }

  return config;
}

export default getGlobalConfigs() || getServerConfigs();



// WEBPACK FOOTER //
// ./src/config/config.js